<div class="pageheader">
    <div class="page-title">
        <h1>Cancelled Messages</h1>
        <div class="btn-group" data-toggle="buttons">
            <button class="btn btn-link" (click)="refresh()" id="saveButton">
                Refresh Data <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
        </div>
    </div>
</div>

<div class="btn-toolbar">
    <div class="btn-group">
        <button class="btn btn-primary btn-sm" [disabled]="selectedDataSourceItems.length <= 0" (click)="showCorrelations()" id="showDocumentsButton">Show Documents</button>
    </div>
</div>

<dx-data-grid id="gridContainer"
              biz-grid
              exportFileName="Cancelled Messages"
              [bizSetStateStoring]="false"
              [selection]='{ mode: "single" }'
              [showCollapseAllButton]="true"
              [bizSetScrolling]="false"
              [dataSource]='dataSourceItems'
              (onSelectionChanged)='selectionChanged($event)'
              bizRowsSelectedTemplate='rowsSelected'>
    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

    <ng-container>
        <dxi-column dataField="CorrelationId" caption="Correlation ID" dataType="string" [visible]="true"></dxi-column>
        <dxi-column dataField="UserName" caption="Cancelled by" dataType="string" [visible]="true"></dxi-column>
        <dxi-column dataField="CancellationDate" caption="Cancellation Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction" sortOrder="desc" [visible]="true"></dxi-column>

        <dxi-column type="buttons">
            <dxi-button text="Show Documents"
                        [visible]="true"
                        [onClick]="showCorrelation">
            </dxi-button>
        </dxi-column>
    </ng-container>

    <div *dxTemplate="let data of 'rowsSelected'">
        <span style="margin-right: 4em; text-wrap: nowrap;">Number of selected rows: {{ data.counter.selectedRows }}</span>
    </div>

    <div *dxTemplate="let row of 'detail'">
        <app-tracking-cancelled-messages-details [correlationId]="row.data.CorrelationId"></app-tracking-cancelled-messages-details>
    </div>
</dx-data-grid>
